import { render, staticRenderFns } from "./type_4.vue?vue&type=template&id=ba6f3c24&scoped=true"
import script from "./type_4.vue?vue&type=script&lang=js"
export * from "./type_4.vue?vue&type=script&lang=js"
import style0 from "./type_4.vue?vue&type=style&index=0&id=ba6f3c24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6f3c24",
  null
  
)

export default component.exports